import React from 'react';
import { Modal, Button } from 'react-bootstrap';

// eslint-disable-next-line react/prop-types
const ConfirmPracticeDialog = ({ show, title, body, onStart, onCancel }) => {
  const handleClose = () => {
    onCancel();
  };
  const handleStart = () => {
    onStart();
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{body}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleStart}>
            Start
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConfirmPracticeDialog;
